import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiDashboardSummary } from '@core/models/api/dashboard.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardApiService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiBaseUrl}/dashboard`;

  getSummary(): Observable<ApiDashboardSummary> {
    return this.http.get<ApiDashboardSummary>(`${this.baseUrl}/summary`);
  }
}
